import React, { Component } from "react";

import "./styles.css";

class PlayerCard extends Component {
  isSelected = () => {
    const { selectedPlayers, player } = this.props;

    if (!selectedPlayers) return false;

    return (
      selectedPlayers.filter(
        (selectedPlayer) => player.playerId === selectedPlayer.playerId
      ).length > 0
    );
  };

  render() {
    const { onSelect, onDeselect, selectedPlayers, player } = this.props;

    return (
      <button
        onClick={this.isSelected() ? onDeselect : onSelect}
        className={`
          PlayerCard
          ${this.isSelected() && " PlayerCard--selected"}
        `}
        key={player.playerId}
      >
        <div
          className="PlayerCard__photo"
          style={{
            backgroundImage: `url('https://static.draft5.gg/jovem-do-ano/players/${
              player.playerImage || "silhueta-masc.png"
            }')`,
          }}
        />

        <h3>{player.playerNick}</h3>
        <small>{player.playerName}</small>
        <small>{player.playerTeam ? player.playerTeam : "Sem Time"}</small>
      </button>
    );
  }
}

export default PlayerCard;
